var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFour6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#2463EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 16.6657C21.3337 19.999 19.0003 21.6657 16.227 22.6323C16.0818 22.6815 15.924 22.6792 15.7803 22.6257C13.0003 21.6657 10.667 19.999 10.667 16.6657V11.999C10.667 11.8222 10.7372 11.6526 10.8623 11.5276C10.9873 11.4026 11.1568 11.3323 11.3337 11.3323C12.667 11.3323 14.3337 10.5323 15.4937 9.519C15.6349 9.39833 15.8146 9.33203 16.0003 9.33203C16.1861 9.33203 16.3658 9.39833 16.507 9.519C17.6737 10.539 19.3337 11.3323 20.667 11.3323C20.8438 11.3323 21.0134 11.4026 21.1384 11.5276C21.2634 11.6526 21.3337 11.8222 21.3337 11.999V16.6657Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour6);
export default __webpack_public_path__ + "static/media/four 6.7ea07e54e6a52694d8a485035a08ad51.svg";
export { ForwardRef as ReactComponent };